import styled from '@emotion/styled';
import { breakpoints } from 'gatsby-theme-apollo';

const Flex = styled.div(props => ({
  display: `flex`,
  flex: `1`,
  flexGrow: `1`,
  justifyContent: props.justifyContent || 'center',
  minWidth: props.minWidth || 'none',
  flexWrap: props.wrap || 'no-wrap',
  flexShrink: props.flexShrink || '0',
  flexDirection: props.flexDirection || 'row',
  alignItems: `center`,
  [breakpoints.xl]: {
    display: props.disappearXL ? 'none' : 'flex'
  },
  [breakpoints.md]: {
    display: props.disappearMD || props.disappearXL ? 'none' : 'flex'
  },
  [breakpoints.sm]: {
    justifyContent: `center`
  }
}));

export { Flex };
